import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { GetRowKey } from "antd/lib/table/interface";
import { IItems, IItemsCheckin } from "store/lobby/lobby-model";
import useTranslation from "utils/hooks/useTranslation";

interface IRenderTable {
  columnsTable: Array<any>;
  items?: Array<IItems> | Array<IItemsCheckin>;
  totalItems?: number;
  pageIndex?: number;
  searchFilter?: string;
  rowKey: GetRowKey<any> | string;
  isLoadingLobby: boolean;
  handleTableChange: (...args) => void;
}

interface IDispatchProps {
  intervalCallApi: (...args) => void;
  lobbyChangeFieldValue: (...args) => void;
  lobbyChangeFieldValueCheckin: (...args) => void;
  lobbyUpdateFilterTable: (...args) => void;
}

type IProps = IRenderTable & IDispatchProps;

const RenderLobbyTable = ({
  columnsTable,
  items,
  totalItems,
  pageIndex,
  searchFilter,
  isLoadingLobby,
  lobbyUpdateFilterTable,
  handleTableChange,
  intervalCallApi,
  lobbyChangeFieldValue,
  lobbyChangeFieldValueCheckin,
  rowKey,
}: IProps): JSX.Element => {
  const [scrollX, setScrollX] = useState(false);
  const SHOWING = useTranslation({ id: "showing" });
  const OF = useTranslation({ id: "of" });
  const REGISTERS = useTranslation({ id: "registers" });

  useEffect(() => {
    if (searchFilter !== "" || searchFilter === null) {
      lobbyChangeFieldValue("pageIndex", 1);
      lobbyChangeFieldValueCheckin("pageIndex", 1);
      lobbyUpdateFilterTable(searchFilter);
      intervalCallApi();
    }
  }, [searchFilter]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1400) {
        setScrollX(true);
      } else {
        setScrollX(false);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ width: "100%", overflowX: scrollX ? "auto" : "visible" }}>
      <Table
        columns={[...columnsTable]}
        dataSource={items}
        pagination={{
          current: pageIndex,
          total: totalItems,
          pageSizeOptions: ["10", "20", "50", "100"],
          defaultPageSize: 10,
          showSizeChanger: true,
          defaultCurrent: pageIndex,
          showTotal: (total, range) => `${SHOWING} ${range[0]}-${range[1]} ${OF} ${total} ${REGISTERS}`,
        }}
        rowKey={rowKey}
        onChange={handleTableChange}
        loading={isLoadingLobby}
        style={{ whiteSpace: "pre-wrap" }}
        scroll={scrollX ? { x: "max-content" } : undefined}
      />
    </div>
  );
};

export default RenderLobbyTable;
